import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Breadcrumbs from "../../../../../ui/Breadcrumbs";
import { makeStyles } from "@material-ui/core/styles";
import Progress from "../../../../../ui/Progress";
import TopBar from "./TopBar";
import Box from "../../../../../ui/Box";
import ResourceForm from "./ResourceForm";
import DeleteConfirmationModal from "../../../../../ui/DeleteConfirmationModal";
import useResourceView from "./useResourceView";

const useStyles = makeStyles(() => ({
  viewRoot: {
    display: "flex",
    background: "#F6FBFF"
  },
  pageRoot: {
    display: "flex",
    flexDirection: "column",
    flexGrow: 1
  },
  topBar: {
    marginBottom: 10
  },
  mainContent: {
    padding: 8,
    maxWidth: 816
  },
  form: {
    width: 385
  },
  twoColumns: {
    display: "flex"
  },
  caption: {
    color: "#778899",
    fontSize: 10,
    marginBottom: 16
  }
}));

const items = [
  {
    label: "Управление ООП",
    link: "#"
  },
  {
    label: "Ресурсы",
    link: "/work/app/manage/resources"
  },
  {
    label: "Информационно-справочные ресурсы",
    link: "/work/app/reference/"
  }
];

const ResourceView = ({ match, history}) => {
  const { id } = match.params;
  const classes = useStyles();

  const {
    resourceData: {
      resourceInfo,
      deleteModalOpen,
      isUpdatingResource,
      isEdited,
    },
    setResourcesData,
    updateResource,
    deleteResource,
    getResource
  } = useResourceView();

  const [isEditable, setEditable] = React.useState(false);

  const returnBack = () => {
    history.push("/work/app/reference");
  }

  useEffect(() => {
    getResource(id);
  }, []);

  return (
    <div>
      <DeleteConfirmationModal
        modalText="Удалить ресурс?"
        open={deleteModalOpen}
        onConfirm={() => {
          deleteResource(id);
          returnBack();
        }}
        handleClose={() => setResourcesData({ deleteModalOpen: false })}
      />
      <Breadcrumbs items={items} />
      {resourceInfo ? (
        <div className={classes.viewRoot}>
          <div className={classes.pageRoot}>
            <div className={classes.topBar}>
              <TopBar
                reload={() => getResource(id)}
                returnBack={returnBack}
                update={() => {
                  updateResource(id, resourceInfo.data);
                }}
                isUpdating={isUpdatingResource}
                openDeleteModal={() =>
                  setResourcesData({ deleteModalOpen: true })
                }
                disabled={!isEdited}
                editmode={isEditable}
                setEditMode={()=>setEditable(true)}
                setViewMode={()=>setEditable(false)}/>
            </div>
            <Box>
                <ResourceForm
                  editmode={isEditable}
                  initialData={resourceInfo.data}
                  disabled={!resourceInfo.info.editable}
                  onFormChange={data =>
                    setResourcesData({ resourceInfo: { ...resourceInfo, data } })
                  }/>
            </Box>
          </div>
        </div>
      ) : (
        <Progress />
      )}
    </div>
  )}

export default withRouter(ResourceView);
